<template>
  <HighlightsWidget
    v-bind="groups"
    showLinkToFullList
    title="Device Groups"
    v-on="$listeners"
  >
    <template v-slot:mainContent>
      <HighlightsStyledList
        :resources="groups.resources"
      />
    </template>
    <template v-slot:zeroState>
      <ZeroState
        icon="/adminportal/device-groups.svg"
        linkText="add a device group"
        message="This device is not connected to a device group."
        v-on="$listeners"
      />
    </template>
  </HighlightsWidget>
</template>

<script>
import HighlightsStyledList from 'client/components/Highlights/HighlightsStyledList.vue';
import HighlightsWidget from 'client/components/Highlights/HighlightsWidget.vue';
import ZeroState from 'client/components/Highlights/ZeroState';

export default {
  name: 'DeviceGroupsWidget',

  components: {
    HighlightsWidget,
    HighlightsStyledList,
    ZeroState,
  },

  props: {
    groups: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
